var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-2 md:px-4 lg:px-10 mx-auto w-full py-24"},[_c('iframe',{staticClass:"h-screen",staticStyle:{"border":"0"},attrs:{"width":"100%","src":_vm.studioUrl,"frameborder":"0","allowfullscreen":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }